import img1 from "../assets/img/_1208766.webp";
import img2 from "../assets/img/_1033783.webp";

import Divider from "../components/divider.js";

function Tanztherapie() {
  return <div className="main-wrapper">
    
    

    

    <h2 className="tanztherapie">Was ist Holistische Tanz- und Bewegungstherapie?</h2>

    <p>
      <strong>Tanztherapie ist eine körperorientierte Psychotherapie</strong> und eine anerkannte Methode, die Bewegung und Tanz für Heilungs- und Integrationsprozesse nutzt. Sie gehört zu den humanistischen Therapiemethoden und ist kreativ und prozessorientiert. Sie setzt bei den gesunden Anteilen des Menschen an, d.h. Krankheit wird weniger als „Störung“ verstanden, sondern eher als Chance, den Körper anhand der Symptome verstehen zu lernen. Es wird davon ausgegangen, dass der Mensch eine angeborene grundlegende Tendenz dazu hat, alle seine körperlichen, seelischen und geistigen Fähigkeiten zu erhalten und weiterzuentwickeln, um sich selbst zu verwirklichen und zu entfalten.
    </p>

    <div className="center">
      <img className="size50" src={img1}/>
    </div>

    <p>
      In der Tanztherapie geht es um authentische Bewegung und kreativen Ausdruck und nicht um festgelegte Schritte oder gar Choreographien. Jeder Mensch drückt sich in seiner ganz eigenen Bewegung mit all seinen Facetten so aus, dass Tanz zum Ausdrucksmittel wird für das, was mit Sprache nicht ausgedrückt werden kann, das, wofür es manchmal keine Worte gibt. Wie der Körper sich bewegt und was er in jedem Moment tut und braucht, ist von zentraler Bedeutung für den therapeutischen Prozess. So können auch unerwünschte, unerlaubte, verdrängte oder unterdrückte Erlebnisinhalte neu und kreativ gestaltet und integriert werden.
    </p>

    <p>
      Tanztherapie kann den authentischen Selbstausdruck, das Empfindungsvermögen und die Selbst- und Fremdwahrnehmung fördern und somit für ein neues Grundvertrauen sowie eine verbesserte Beziehungsfähigkeit sorgen. Außerdem können Selbstheilungskräfte und kreativen Potentiale gestärkt werden.
    </p>

    <Divider/>

    <p>
      <strong>Die Holistische Tanz- und Bewegungstherapie (HTB)</strong> geht darüber hinaus und integriert Aspekte aus Tiefenpsychologie, Verhaltenstherapie, Familientherapie, modernen Körpertherapien (wie z.B. Continuum) und neueste Erkenntnisse der Ökopsychologie.
    </p>

    <p>
      Die Ökopsychologie (früher auch Tiefenökologie genannt) geht davon aus, dass der Mensch in der industriellen Konsumgesellschaft weitgehend von seinem Körper entfremdet ist, v.a. weil Leistungsfähigkeit und Funktionalität des Körpers überbetont werden. Der Mensch entfremdet sich dadurch auch von seinen Gefühlen, seinen Werten, seinem Lebensraum und seiner Umwelt. Mögliche Folgen sind Erkrankungen an Körper und Seele, mangelnde Lebensfreude, Hoffnungslosigkeit und Sinnverlust.<br/>
      Die HTB zielt darauf ab, die Entfremdung des Menschen von sich selbst, von seiner Familie (dem Gegenüber) und von der Gesellschaft (der Gruppe), sowie auch die Entfremdung des Menschen von seiner Mitwelt (Umwelt, Natur) zu heilen. Deshalb nennt sich dieser Ansatz „holistisch“ (=ganzheitlich).
    </p>

    <p>
      Für diesen ganzheitlichen Heilungsprozess spielen Tanz und Bewegung eine zentrale Rolle. Im Erfahren der eigenen Bewegung wird spürbar, dass alles Leben „tanzt“:<br/>
      Wenn ich lebe, drücke ich meine Lebenskraft durch Bewegung aus – wenn ich mich bewege, fühle ich meine Lebenskraft und Lebendigkeit. Dadurch wird es möglich, sich als lebendiges Ganzes wahrzunehmen.
    </p>

    <div className="center">
      <img className="size50" src={img2}/>
    </div>

  </div>;
}
export default Tanztherapie;